export default {
  alaskaair: {
    name: 'Alaska Airlines',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Alaska_Airlines.zip',
  },
  ascent: {
    name: 'Ascent',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Ascent.zip',
  },
  amex: {
    name: 'American Express',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/American_Express.zip',
  },
  aspca: {
    name: 'ASPCA',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/ASPCA.zip',
  },
  bankofamerica: {
    name: 'Bank of America',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Bank_of_America.zip',
  },
  bestegg: {
    name: 'Best Egg',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Best_Egg.zip',
  },
  bettermortgage: {
    name: 'Better Mortgage',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Better_Mortgage.zip',
  },
  bluevine: {
    name: 'Bluevine',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Bluevine.zip',
  },
  capitalone: {
    name: 'Capital One',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Capital_One.zip',
  },
  charlesschwab: {
    name: 'Charles Schwab',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Charles_Schwab.zip',
  },
  collegeave: {
    name: 'College Ave',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/College_Ave.zip',
  },
  chase: {
    name: 'Chase',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Chase.zip',
  },
  chime: {
    name: 'Chime',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Chime.zip',
  },
  citi: {
    name: 'Citi',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Citi.zip',
  },
  discover: {
    name: 'Discover',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Discover.zip',
  },
  earnest: {
    name: 'Earnest',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Earnest.zip',
  },
  fidelity: {
    name: 'Fidelity Investments',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Fidelity-Investments.zip',
  },
  geico: {
    name: 'Geico',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/GEICO.zip',
  },
  interactivebrokers: {
    name: 'Interactive Brokers',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Interactive_Brokers.zip',
  },
  lemonade: {
    name: 'Lemonade',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Lemonade.zip',
  },
  lendingclub: {
    name: 'LendingClub',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Lending_Club.zip',
  },
  lightstream: {
    name: 'LightStream',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/LightStream.zip',
  },
  loansdepot: {
    name: 'loanDepot',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/LoansDepot.zip',
  },
  marcus: {
    name: 'Marcus by Goldman Sachs',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Marcus_by_Goldman_Sachs.zip',
  },
  marriott: {
    name: 'Marriott',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Marriott.zip',
  },
  navy: {
    name: 'Navy Federal Credit Union',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Navy_Federal_CU.zip',
  },
  newtek: {
    name: 'Newtek',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Newtek.zip',
  },
  pointsyeah: {
    name: 'PointsYeah',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/PointsYeah.zip',
  },
  realgenius: {
    name: 'Real Genius',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Real_Genius.zip',
  },
  rocket: {
    name: 'Rocket Mortgage',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Rocket_Mortgage2.zip',
  },
  sofi: {
    name: 'SoFi',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/SoFi.zip',
  },
  sofistudentloans: {
    name: 'SoFi Student Loans',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Sofi_Student_Loans.zip',
  },
  travelers: {
    name: 'Travelers',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Travelers.zip',
  },
  truist: {
    name: 'Truist',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Truist.zip',
  },
  united: {
    name: 'United',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/United.zip',
  },
  upgrade: {
    name: 'Upgrade',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Upgrade.zip',
  },
  upstart: {
    name: 'Upstart',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Upstart.zip',
  },
  usbank: {
    name: 'U.S. Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/US_Bank.zip',
  },
  wealthfront: {
    name: 'Wealthfront',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Wealthfront.zip',
  },
  wellsfargo: {
    name: 'Wells Fargo',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/Wells_Fargo2.zip',
  },
  worldofhyatt: {
    name: 'World of Hyatt',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/World_of_Hyatt.zip',
  },
  zynlo: {
    name: 'ZYNLO',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2026-partners/badges/v1/ZYNLO.zip',
  },
};
